<template>
	<article class="booking_service_selection">
		<section class="pages_content">
			<div class="booking_info">
				<div class="depart">
					<div class="info_wrap flex_wrap" @click="choosePickupAddress">
						<span>接送地址</span>
						<span class="text_width site_name_w">{{ DefaultAddress.District + '-' + DefaultAddress.Address }}</span>
					</div>
					<div class="icon_wrap"><i class="iconfont icon-iconfontzhizuobiaozhun19"></i></div>
				</div>
				<div class="luggage flex_wrap a_i_center" @click="showLuggageCountList">
					<span>行李件数</span>
					<span class="select_luggage">{{ LuggageCount }}</span>
					<i class="iconfont icon-iconfontzhizuobiaozhun19"></i>
				</div>
			</div>

			<div class="booking_service_description">
				<h3 class="article_title red_color">接送车服务须知</h3>
				<!-- <p class="p_title">一、注意事项</p> -->
				<p class="red-text">*当天12:30以前的班车接送，在乘车前一天下午18:00左右通知接送时间</p>
				<p class="red-text">*当天12:30以后的班车接送，在乘车当天早上10:00左右通知接送时间</p>

				<p class="p_title">一、预约接送服务需至少提前一天在[中山市旅游集散中心]公众号上提前购买。</p>
				<p class="p_title">
					二、请旅客收到接送时间后，提前到达接送地点，并保持电话畅通。若您所提供的电话号码长时间处于无人接听、忙音等状况而使我们不能及时联系到您，由此造成的损失，均由旅客本人负责。
				</p>
				<p class="p_title">
					三、由于旅客自身原因，未能准时到达预约地点的，且未提前联系客服0760-88880777说明原因的，逾时5分钟后视为自动放弃接送服务，接送费用照收，不作另外退还，非司机原因（如堵车、他人责任的交通事故等）造成旅客的延误或其他损失，我方不承担相应的责任。
				</p>
				<p class="p_title">四、服务车型为5座轿车，服务价格以我司移动端现行公示为准，旅客在我们的页面查看相关服务的价格。现行服务价格标准如下：</p>

				<div class="table xingli">
					<ul class="tr bg_th_orderinfo">
						<li class="th">起/止地</li>
						<li class="th">价格</li>
						<!-- <li class="th">包车价格/车</li> -->
					</ul>
					<ul v-for="(item, key, index) in priceTable" :key="index" class="tr">
						<li class="td">{{ item.District }}</li>
						<li class="td">{{ item.singlePrice }}/人</li>
						<!-- <li class="td">{{ item.doublePrice }}元/车</li> -->
					</ul>
				</div>
				<p class="text-center red-text">2人8折、3人7折、4人6折。</p>
				<p class="text-center red-text">注：以上价格随时可能更新，具体以页面公示最新价格标准为准。</p>

				<p class="">A. 单人或2-3人购买接送服务，沿途拼车，同一订单同一地址视为1单接送，每车4位乘客为上限。</p>
				<p class="">B. 4人购买接送服务，同一订单同一地址视为包车接送.</p>
				<p class="p_title">五、行李件数：</p>
				<p class="">
					拼车每人可免费携带26寸以下行李1件(4人同一订单同一地址视为包车,行李总数不超4件)，超出行李（26寸以上按2件计算）按10元/件收取费用，若行李较多可在下单前电话咨询。
				</p>
				<p class="p_title">
					六、接送服务在未安排车辆和未通知接送时间前，旅客取消接送，不收取接送费；若已安排接送车辆并通知接送时的，由于旅客个人原因，需要取消接送服务的，视为自动放弃接送服务，不作另外退还。
				</p>
				<p class="p_title">
					七、旅客不得携带危险品或者其他法律、法规规定禁止或不适宜携带的物品搭乘车辆驾驶员的车辆，否则车辆驾驶员有权拒绝提供服务,并由旅客承担任何携带该等物品引起的后果和责任。
				</p>
				<p class="p_title">八、旅客不得在不乘坐车辆的情况下,委托驾驶员单独运送物品。</p>
				<p class="p_title">
					九、旅客不得在使用服务过程中进行违反平台规则的不文明的行为(包括吸烟、喝酒、吐痰、辱骂或殴打驾驶员) ,
					不得进行或要求车辆驾驶员进行违反相关交通规则或者其他法律法规的行为，因旅客违反禁止行为的原因导致有关部门行政处罚、人员受伤、发生交通事故、造成车辆损坏或其他损失的,旅客应向受损方进行赔偿
				</p>
				<p class="p_title">
					十、旅客应当具备完全民事行为能力(年满18周岁或年满16周岁、以自己的劳动收入为主要生活来源,且精神健康能完全辨认自己的行为) ,
					同时,旅客应当保证发布出行信息时是自愿的,且不存在意识不清楚、醉酒等情形。若旅客有意识不清楚、醉酒等情形的，陪同人员代为发布的出行需求信息视为旅客的行为;；在旅客醉酒或存在其他意识不清楚的情况下,应当由意识清楚的第三方陪同;；在旅客饮酒、醉酒或意识不清楚的情况下,给他人造成损失的,旅客本人应当就相应损失予以赔偿。
				</p>
			</div>
			<div class="mask_btn_wrap">
				<button class="" @click="unChoosePickupService">不需接送</button>
				<button class="tijiaoyuyue" @click="choosePickupService">预约接送服务</button>
			</div>
		</section>
	</article>
</template>

<script>
import { mapState } from 'vuex';
import frequencyApi from '../request/frequencyApi';
export default {
	name: 'ChoosePickupService',
	data() {
		return {
			defaultAddress: {},
			// selectedFrequency: {},
			luggageCount: 0,
			luggageCountArray: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
			pickupAreaPriceList: [],
			selectedPickupPriceModel: null,
			priceTable: []
		};
	},
	activated() {
		// this.getValue();
		this.$store.dispatch('ticket/getDefaultAddress', this.$store.state.user.OpenId);
		this.$store.dispatch('boat/getDefaultAddress', this.$store.state.user.OpenId);
		// this.getPickupAreaPrice();
	},
	methods: {
		setStoreData(obj) {
			this.$store.commit('ticket/setBaseTicketCondition', obj);
			this.$store.commit('boat/setBaseBoatCondition', obj);
		},
		getValue() {
			// this.selectedFrequency = this.$route.params.frequency;
		},
		choosePickupAddress() {
			this.$router.push({
				name: 'MyAddressManager',
				params: {
					mode: 'choose'
				}
			});
		},
		choosePickupService() {
			this.setStoreData({ DefaultAddress: this.DefaultAddress });
			this.$router.go(-1);
		},
		// 生成价格表
		makePriceTable() {
			let tmpPriceArr = [];
			this.priceTable = [];
			for (let i = 0; i < this.pickupAreaPriceList.length; i++) {
				if (this.pickupAreaPriceList[i].Status) {
					let tmpPrice = this.pickupAreaPriceList[i].Price;
					if (tmpPriceArr.indexOf(tmpPrice) == -1) tmpPriceArr.push(tmpPrice);
				}
			} // 生成价格数组
			tmpPriceArr.sort((val1, val2) => {
				return val1 - val2;
			});
			for (let i = 0; i < tmpPriceArr.length; i++) {
				let tmpDistrictStr = '';
				for (let j = 0; j < this.pickupAreaPriceList.length; j++) {
					if (this.pickupAreaPriceList[j].Price == tmpPriceArr[i] && this.pickupAreaPriceList[j].Status) tmpDistrictStr += this.pickupAreaPriceList[j].District + '、';
				}
				tmpDistrictStr = tmpDistrictStr.substring(0, tmpDistrictStr.length - 1);
				let priceComputedDescription = '';
				priceComputedDescription += Math.round(tmpPriceArr[i]) + '/1人 ';
				priceComputedDescription += Math.round(tmpPriceArr[i] * 2 * 0.8) + '/2人 ';
				priceComputedDescription += Math.round(tmpPriceArr[i] * 3 * 0.7) + '/3人 ';
				priceComputedDescription += Math.round(tmpPriceArr[i] * 4 * 0.6) + '/4人';
				var tmpObj = { District: tmpDistrictStr, singlePrice: tmpPriceArr[i], doublePrice: tmpPriceArr[i] * 2, priceComputedDescription: priceComputedDescription };
				this.priceTable.push(tmpObj);
			}
		},
		unChoosePickupService() {
			this.$store.commit('ticket/setTicketMode');
			this.$store.commit('boat/setTicketMode');
			this.$router.go(-1);
		},
		showLuggageCountList() {
			let that = this;
			let tmpArray = new Array();
			for (let i = 0; i < this.luggageCountArray.length; i++) {
				let tmp = {
					label: this.luggageCountArray[i],
					value: this.luggageCountArray[i]
				};
				tmpArray.push(tmp);
			}
			this.$weui.picker(tmpArray, {
				onConfirm(result) {
					let count = result[0].value;
					console.log('luggageCountSelected->', count);
					that.setStoreData({ LuggageCount: parseInt(count) });
					// that.luggageCount = result[0].value;
				}
			});
		}
	},
	computed: mapState({
		DefaultAddress: state => state.ticket.DefaultAddress,
		PickupPriceModel: state => state.ticket.PickupPriceModel,
		LuggageCount: state => state.ticket.LuggageCount
	})
};
</script>

<style scoped lang="less">
@import '../style/public';

.booking_service_selection {
	height: 100%;
	.overfH;
}
.pages_content {
	flex: none;
	max-height: 100%;
	overflow: hidden;
	.flex_wrap(space-between, initial, initial, column);
}
.booking_service_selection .booking_info .iconfont {
	margin: 0 10px;
}
.booking_info {
	margin: 5px 3% 0;
	flex: 0 0 auto;
	/*margin-top: 5px;*/
}
.booking_info > div {
	/*padding-left: 3%;*/
	border: 1px solid #888;
	border-radius: 5px;
	margin-top: 10px;
}
.booking_info .info_wrap {
	flex: 1;
	.flex_wrap;
}
.booking_info .info_wrap > span:first-child,
.booking_info .luggage > span:first-child {
	padding: 0 0.3rem;
	border-right: 1px solid #888;
	background-color: #E77618;
	color: #fff;
	border-radius: 4px 0 0 4px;
}
.booking_info .info_wrap > span:last-child,
.booking_info .luggage > span:last-of-type {
	margin-left: 10px;
}
.booking_service_description {
	width: auto;
	margin: 2% 3%;
	flex: 1;
	overflow: auto;
}
.booking_service_description > h3 {
	font-size: 0.5rem !important;
	text-align: center;
}
.booking_service_description > p {
	text-indent: 2em;
	margin: 5px auto;
	font-size: 0.4rem;
}
.mask_btn_wrap {
	.flex_wrap;
	flex: 0 0 auto;
	button {
		flex: 1;
		line-height: 1.1rem;
	}
}
.booking_service_selection .mask_btn_wrap > button:last-child {
	color: #fff;
	background-color: #E77618;
}
.booking_service_selection .mask_btn_wrap > button:last-child:active {
	color: #eee;
	background-color: #1d8ac5;
}

.depart,
.luggage,
.destination,
.passenger,
.departure_day,
.flight_wrap {
	font: 400 0.4rem/1rem '微软雅黑';
}
.depart,
.luggage {
	.flex_wrap(space-between, center);
}
</style>



// WEBPACK FOOTER //
// src/components/ChoosePickupService.vue